import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items"];
import { Divider, Grid, Menu, MenuItem, Toolbar, Typography } from '@material-ui/core';
import { MoreHoriz } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import { forwardRef, useRef, useState } from 'react';
import { Button } from "../button/Button.js";
import { DropdownButton } from "../dropdown-button/DropdownButton.js";
import { useResizeObserver } from "../utils/ResizeObserver.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = /*#__PURE__*/makeStyles({
  actions: {
    overflow: 'hidden'
  }
}, {
  name: 'SD-AdaptiveToolbar'
});
export var AdaptiveToolbar = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      items
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyles();
  var itemNodes = useRef([]);
  var optionsButtonRef = useRef(null);
  var [firstHiddenIdx, setFirstHiddenIdx] = useState(-1);
  var menuItems = firstHiddenIdx === -1 ? [] : items.slice(firstHiddenIdx);
  var [menuButtonNode, setMenuButtonRef] = useState();
  var [rootNode, setRootNode] = useState(null);
  useResizeObserver(rootNode, node => {
    var _optionsButtonRef$cur;
    var rootRect = node.getBoundingClientRect();
    var rootWidth = rootRect.left + rootRect.width;
    var optionsButtonRect = (_optionsButtonRef$cur = optionsButtonRef.current) === null || _optionsButtonRef$cur === void 0 ? void 0 : _optionsButtonRef$cur.getBoundingClientRect();
    var optionsButtonWidth = (optionsButtonRect === null || optionsButtonRect === void 0 ? void 0 : optionsButtonRect.width) || 0;
    var maxRightPosition = rootWidth - optionsButtonWidth;
    var mountedNodes = itemNodes.current.filter(x => x != null);
    var hiddenIdx = mountedNodes.findIndex((itemNode, idx) => {
      itemNode.removeAttribute('hidden');
      var itemRect = itemNode.getBoundingClientRect();
      var itemRightPosition = itemRect.left + itemRect.width;

      // Ignore options button width when checking last item.
      if (idx === mountedNodes.length - 1) {
        return itemRightPosition > rootWidth;
      }
      return itemRightPosition > maxRightPosition;
    });
    if (hiddenIdx !== -1) {
      mountedNodes.slice(hiddenIdx).forEach(itemNode => {
        itemNode.setAttribute('hidden', 'true');
      });
    }
    setFirstHiddenIdx(hiddenIdx);
  });
  return /*#__PURE__*/_jsx(Toolbar, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    children: /*#__PURE__*/_jsxs(Grid, {
      container: true,
      spacing: 1,
      ref: setRootNode,
      children: [/*#__PURE__*/_jsx(Grid, {
        item: true,
        className: styles.actions,
        children: /*#__PURE__*/_jsx(Grid, {
          container: true,
          spacing: 1,
          wrap: "nowrap",
          component: "div",
          children: items.map((item, idx) => /*#__PURE__*/_jsx(Grid, {
            item: true,
            ref: node => {
              itemNodes.current[idx] = node;
            },
            children: item.dropdown ? /*#__PURE__*/_jsx(DropdownButton, _objectSpread(_objectSpread({
              type: "button",
              onClick: item.onClick,
              label: item.label
            }, item.ButtonProps), {}, {
              children: item.dropdown.map(dropdownItem => /*#__PURE__*/_jsx(MenuItem, {
                onClick: dropdownItem.onClick,
                children: dropdownItem.label
              }, dropdownItem.key))
            })) : /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
              type: "button",
              onClick: item.onClick
            }, item.ButtonProps), {}, {
              children: /*#__PURE__*/_jsx(Typography, {
                noWrap: true,
                variant: "inherit",
                children: item.label
              })
            }))
          }, item.key))
        })
      }), menuItems.length > 0 && /*#__PURE__*/_jsxs(Grid, {
        item: true,
        ref: optionsButtonRef,
        component: "div",
        children: [/*#__PURE__*/_jsx(Button, {
          type: "button",
          onClick: _ref2 => {
            var {
              currentTarget
            } = _ref2;
            setMenuButtonRef(currentTarget);
          },
          children: /*#__PURE__*/_jsx(MoreHoriz, {})
        }), /*#__PURE__*/_jsx(Menu, {
          open: !!menuButtonNode,
          anchorEl: menuButtonNode,
          onClose: () => {
            setMenuButtonRef(undefined);
          },
          children: menuItems.map((item, index, arr) => {
            var _item$dropdown;
            var next = arr[index + 1];
            return /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(MenuItem, {
                onClick: event => {
                  var _item$onClick;
                  (_item$onClick = item.onClick) === null || _item$onClick === void 0 ? void 0 : _item$onClick.call(item, event);
                  setMenuButtonRef(undefined);
                },
                children: item.label
              }, item.key), (_item$dropdown = item.dropdown) === null || _item$dropdown === void 0 ? void 0 : _item$dropdown.map(dropdownItem => /*#__PURE__*/_jsx(MenuItem, {
                onClick: event => {
                  var _dropdownItem$onClick;
                  (_dropdownItem$onClick = dropdownItem.onClick) === null || _dropdownItem$onClick === void 0 ? void 0 : _dropdownItem$onClick.call(dropdownItem, event);
                  setMenuButtonRef(undefined);
                },
                children: dropdownItem.label
              }, dropdownItem.key)), next && item.groupKey !== next.groupKey && /*#__PURE__*/_jsx(Divider, {})]
            });
          })
        })]
      })]
    })
  }));
});
if (process.env.NODE_ENV !== "production") AdaptiveToolbar.displayName = "AdaptiveToolbar";